module.exports = __webpack_public_path__ + "img/poa.2c9961ab.svg";